import logo from './uppies.gif';
import './App.css';
import de from './de.jpg'
function App() {
  return (
    <div className="App">
        <h1>UPPIES</h1>
        <img src={logo} className="App-logo" alt="logo" />
        <p className="ca">CA: 0x9bCeA390ff97e0d3362bf726820776a4dF8AdD9a</p>
        <p><a href="https://degen.express/sonic/token/0x9bCeA390ff97e0d3362bf726820776a4dF8AdD9a" target="_blank">
        	<img className="de" src={de} />
        </a></p>
    </div>
  );
}

export default App;
